import React, { Component } from 'react';
// images
const CompletedIcon = require('../../images/status-complete.svg');
const InProgressIcon = require('../../images/status-in-progress.svg');
const PendingIcon = require('../../images/status-pending.svg');
const UrgentAttention = require('../../images/urgentAction.svg');
const CompleteWithWarningIcon = require('../../images/complete-warn.svg');
// styles
const styles = require('./status-list-component.scss');

interface IProps {
  language: string;
  multiLang: any;
  bagsJourney: any;
  processTrackingStatus?: any;
}

enum BagsJourneyType {
  Collected = 1,
  InTransit = 2,
  InStorage = 3,
  OutOfStorage = 4,
  CheckedIn = 5,
  Downgraded = 6,
  WithCourier = 7,
  Delivered = 8,
  NotCollected = 9
}

enum BagsJourneyStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  UrgentAttention = 4,
  PartiallyCompleted = 5
}

const IMAGE_MAP = {
  Pending: PendingIcon,
  InProgress: InProgressIcon,
  Completed: CompletedIcon,
  UrgentAttention: UrgentAttention,
  CompleteWithWarning: CompleteWithWarningIcon,
  NotCollected: UrgentAttention,
}

const TITLE_MAP = {
  Collected: 'Bags collected',
  InTransit: 'Bags out for delivery',
  InStorage: 'Bags placed in storage',
  OutOfStorage: 'Bags collected from storage',
  CheckedIn: 'Bags checked in',
  Downgraded: 'Bags not checked in',
  WithCourier: 'Bags with courier',
  Delivered: 'Bags delivered',
  NotCollected: 'Bags not collected'
}

const STATUS_MAP = {
  Pending: 'pendingTitle',
  InProgress: 'inProgressTitle',
  Completed: 'completeTitle',
  UrgentAttention: 'Urgent attention',
}

export class StatusList extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() { }

  render() {
    const { bagsJourney = [], multiLang, language, processTrackingStatus } = this.props; // multiLang, language,

    return (
      <div className={styles.list}>
        {
          bagsJourney?.map((journeyItem, index) => {

            const title = TITLE_MAP[BagsJourneyType[journeyItem.bagsJourneyType]];
            const status = STATUS_MAP[BagsJourneyStatus[journeyItem.bagsJourneyStatus]];
            const bagsStatus = !processTrackingStatus || processTrackingStatus?.bookedBagCount !== processTrackingStatus?.collectedBagCount
            const partialCollection = bagsStatus && journeyItem.bagsJourneyType === BagsJourneyType.NotCollected && journeyItem.bagsJourneyStatus === BagsJourneyStatus.PartiallyCompleted;
            const dateCheck = journeyItem?.dateTimeText.match(/today|tomorrow/ig);
            const jobDateTime = dateCheck ? multiLang[dateCheck[0].toLowerCase() + language] + journeyItem.dateTimeText.replace(dateCheck[0], '') : journeyItem.dateTimeText;
            // const notCollected = journeyItem.bagsJourneyType === BagsJourneyType.NotCollected && journeyItem.bagsJourneyStatus === BagsJourneyStatus.PartiallyCompleted;
            return <>
              <div
                className={styles.list_item}
                key={index}
              >
                <div className={styles.list_item_section}>
                  <img src={IMAGE_MAP[partialCollection ? 'CompleteWithWarning' : BagsJourneyStatus[journeyItem.bagsJourneyStatus]]} width={40} height={40} />

                  <div>
                    <h3 className={styles.title}>
                      {multiLang[`${title}${language}`] ?? title}
                    </h3>
                    <p className={styles.status} >
                      {multiLang[`${status}${language}`] ?? status} {partialCollection && processTrackingStatus && `(${processTrackingStatus.collectedBagCount}/${processTrackingStatus.bookedBagCount} ${multiLang['ofBags' + language]})`}
                    </p>
                  </div>
                </div>

                <div>
                  <p className={styles.dateTime}>{jobDateTime}</p>
                </div>
              </div>
              <div className={styles.divider}></div>
            </>
          })
        }</div>
    );
  }
}

export default StatusList;



// WEBPACK FOOTER //
// ./src/components/arrival-status-list-component/status-list-component.tsx